import { request } from "../client";

import type {
  ProgressTrackingRequest,
  ProgressTrackingResponse,
  FeatureAccessResponse,
  AdaptiveStudyStatsResponse,
  VoicesResponse,
  VoicesByLanguageResponse,
} from "../types/features";

export function createFeaturesEndpoints(baseUrl: string): {
  trackProgress: (
    payload: ProgressTrackingRequest,
    token?: string | null,
  ) => Promise<ProgressTrackingResponse>;
  checkFeatureAccess: (
    feature: string,
    token?: string | null,
  ) => Promise<FeatureAccessResponse>;
  getAdaptiveStudyStats: (
    days: number,
    token?: string | null,
  ) => Promise<AdaptiveStudyStatsResponse>;
  getVoices: (token?: string | null) => Promise<VoicesResponse>;
  getVoicesByLanguage: (
    language: string,
    token?: string | null,
  ) => Promise<VoicesByLanguageResponse>;
} {
  return {
    /**
     * Записать прогресс изучения текста
     */
    trackProgress(
      payload: ProgressTrackingRequest,
      token?: string | null,
    ): Promise<ProgressTrackingResponse> {
      return request<ProgressTrackingResponse>(baseUrl, "/progress/track", {
        method: "POST",
        body: payload,
        token,
      });
    },

    /**
     * Проверить доступ к функции
     */
    checkFeatureAccess(
      feature: string,
      token?: string | null,
    ): Promise<FeatureAccessResponse> {
      return request<FeatureAccessResponse>(
        baseUrl,
        `/features/access/${feature}`,
        {
          method: "GET",
          token,
        },
      );
    },

    /**
     * Получить статистику адаптивного обучения
     */
    getAdaptiveStudyStats(
      days: number,
      token?: string | null,
    ): Promise<AdaptiveStudyStatsResponse> {
      return request<AdaptiveStudyStatsResponse>(
        baseUrl,
        `/dictionary/adaptive/stats?days=${days}`,
        {
          method: "GET",
          token,
        },
      );
    },

    /**
     * Получить все голоса
     */
    getVoices(token?: string | null): Promise<VoicesResponse> {
      return request<VoicesResponse>(baseUrl, "/voices", {
        method: "GET",
        token,
      });
    },

    /**
     * Получить голоса для языка
     */
    getVoicesByLanguage(
      language: string,
      token?: string | null,
    ): Promise<VoicesByLanguageResponse> {
      return request<VoicesByLanguageResponse>(
        baseUrl,
        `/voices/language/${language}`,
        {
          method: "GET",
          token,
        },
      );
    },
  };
}
